
import {addServiceGroups,deleteServiceGroup,updateServiceGroups,getServiceGroups,getServiceGroup,searchServiceGroup } from '@/services/endpoints/serviceGroups'
import {searchDiscountGroup} from "@/services/endpoints/discountGroups";
import statuses from "@/constatnts/statuses";

export default {
    async addServiceGroups({ commit }, payload) {
        try {
            let res = await addServiceGroups(payload)
            if(res) {
                return res.data
            }
            else{
                throw {}
            }
        }
        catch (err) {
            throw err
        }
    },

    async deleteServiceGroup({ commit }, payload) {
        try {
            let res = await deleteServiceGroup(payload.serviceGroupsId)
            if(res) {
                return res.data
            }
            else{
                throw {}
            }
        }
        catch (err) {
            throw err
        }
    },
    async getActiveServiceGroups({ commit }) {
        try {
            let res = await searchServiceGroup({ status: statuses.ACTIVE });
            if (res) {
                
                commit("SET_ACTIVE_SERVICE_GROUPS", res.data.data);
                return res.data.data;
            }
        } catch (err) {
            
            throw new Error(err);
        }
    },
    async getServiceGroups({ commit },payload) {
        try {
            let res = await getServiceGroups(payload);
            if(res) {
                commit('SET_SERVICE_GROUPS', res.data.data)
                commit('SET_TOTAL', res.data.total)
                return res.data.data
            }
        }
        catch (err) {
            throw new Error(err)
        }
    },
    async updateServiceGroups({commit},payload) {
        try {
            let res = await updateServiceGroups(payload.id, payload.payload);
            if(res) {
                return res.data
            }
            else{
                throw {}
            }
        }
        catch (err) {
            throw err
        }
    },
    async searchServiceGroup({ commit }, payload) {
        try {
            let res = await searchServiceGroup(payload);
            if(res) {
                commit('SET_SERVICE_GROUPS', res.data.data)
                commit('SET_TOTAL', res.data.total)
                return res.data.data
            }
        }
        catch (err) {
            throw new Error(err)
        }
    },
    async getServiceGroupsToEdit({ commit }, serviceGroupsId) {
        try {
            let res = await getServiceGroup(serviceGroupsId);
            if(res) {
                commit('SET_SERVICE_GROUPS_TO_EDIT', res.data)
                return res.data
            }
        }
        catch (err) {
            throw new Error(err)
        }
    },
}